/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanyJobType {
    DRAFT = 'draft',
    FILE = 'file',
}
